export default {
    Statistics: 'Статистика',
    WeeklySales: 'Продажи за неделю',
    Distribution: 'Дистрибуция',
    Adobe: 'Adobe',
    Quarter: 'Квартал',
    Products: 'Продукты',
    Orders: 'Заказы',
    Events: 'Мероприятия',
    News: 'Новости',
    Library: 'Библиотека',
    Settings: 'Настройки',
    Countries: 'Страны',
    Users: 'Пользователи',
    Categories: 'Категории',
    Prizes: 'Призы',
    WonPrizes: 'Выигранные Призы',
    Markup: 'Наценка',
    MarkupGroup: 'Группа Наценки',
    Targets: 'Цели',
    Groups: 'Группы',
    groups: 'Группа',
    View: 'Просмотр',

    royalty: 'Royalty',
    dealerPrice: 'Диллерская цена',
    id: 'ID',
    title: 'Заголовок',
    action: 'Действие',
    edit: 'Редактировать',
    delete: 'Удалить',
    parent: 'Главная Категория',
    save: 'Сохранить',
    add: 'Добавить',
    PriceDetails: 'Детали о цене',
    total: 'Общая',
    NotEnoughMoney: 'Невозможно разместить заказ.<br>Сумма вашего заказа превышает остаток вашего кредитного лимита.',
    PLACEORDER: 'ЗАКАЗАТЬ',
    BrowseProducts: 'Рассмотреть продукты',
    ExportToExcel: 'Экспортировать в Excel',
    image: 'Картинка',
    startAt: 'Дата начала',
    endAt: 'Дата конца',
    createdAt: 'Было создано',
    start: 'Начало',
    end: 'Конец',
    description: 'Описание',
    products: 'Продукты',
    prizes: 'Призы',
    confirm: 'Подтвердить',
    doYouWantToDelete: 'Вы хотите удалить',
    view: 'Просмотр',
    more: 'Далее',
    points: 'Баллы',
    RecoverYourPassword: 'Восстановить пароль',
    RecoverYourPasswordDesc: 'Пожалуйста, введите свой адрес электронной почты, и мы вышлем вам инструкции о том, как восстановить пароль.',
    BackToLogin: 'Назад в Логин',
    password: 'Пароль',
    ConfirmPassword: 'Подтвердить Пароль',
    RecoverPassword: 'Восстановить Пароль',
    ChangePassword: 'Изменить Пароль',
    ChangeInformation: 'Изменить Информацию',
    MyPrizes: 'Мои призы',
    users: 'Пользователи',
    file: 'Файл',
    OldFile: 'Старый Файл',
    download: 'Скачать',
    login: 'Логин',
    loginDesc: 'Добро пожаловать, пожалуйста, войдите в свой аккаунт.',
    RememberMe: 'Запомнить меня',
    ForgotPassword: 'Забыли Пароль?',
    SubTitle: 'Подзаголовок',
    status: 'Статус',
    date: 'Дата',
    viewAll: 'Посмотреть все',
    fromDate: 'От даты',
    toDate: 'До даты',
    searchById: 'Искать по Id',
    searchBySku: 'Искать по SKU',
    searchByProductName: 'Искать по названию продукта',
    productName: 'Название продукта',
    userGroup: 'Группа пользователей',
    sku: 'SKU',
    quantity: 'Количество',
    quantity_short: 'Кол-во',
    UnitPrice: 'Цена за единицу товара',
    price: 'Цена',
    ProductName: 'Название продукта',
    keys: 'Ключи',
    TotalPrice: 'Общая Сумма',
    comment: 'Комментарий',
    comments: 'Комментарии',
    DealerName: 'Дилер',
    UserName: 'Имя пользователя',
    InStock: 'Доступно',
    NotInStock: 'Не Доступно',
    NotEnoughPoint: 'Не достаточно баллов',
    TakeAPrize: 'Получите приз',
    count: 'Количество',
    point: 'Баллы',
    category: 'Категория',
    amount: 'Цена',
    about: 'Личные данные',
    CompanyName: 'Название компании',
    voen: 'VÖEN',
    contract_number: 'Номер контракта',
    contract_start_at: 'Дата контракта',
    MPNID: 'MPN ID',
    name: 'Имя',
    emailAddress: 'Электронный адрес',
    phone: 'Телефон',
    FinCode: 'Fin Код',
    country: 'Страна',
    joined: 'Дата регистрации',
    OldPassword: 'Старый пароль',
    NewPassword: 'Новый пароль',
    ConfirmNewPassword: 'Подтвердите новый пароль',
    change: 'Изменить',
    Months: 'Месяцы',
    Sum: 'Сумма',
    TargetProgress: 'Прогресс Цели',
    toComplete: 'завершено',
    BestSeller: 'Лучший Продавец',
    Top5Products: 'Top 5 Продуктов',
    targetDesc: 'После добавления цели вы не можете удалить и изменить ее.',
    limit: 'Лимит',
    spent: 'Потрачено',
    bonus: 'Бонус',
    photo: 'Фото',
    event: 'Мероприятие',
    prize: 'Приз',
    unlimited: 'Сделать безлимитным?',
    ExportasCSV: 'Экспортировать как CSV',
    ConfirmTaken: 'Подтвердить полученное',
    Taken: 'Полученное',
    PartnerStatus: 'Статус партнера',
    RemainingCreditLimit: 'Оставшийся кредитный лимит',
    items: 'Предметы',
    InYourCart: 'В вашей корзине',
    checkout: 'Оформить заказ',
    YourCartIsEmpty: 'Ваша корзина пуста.',
    profile: 'Профиль',
    logout: 'Выйти',
    activate: 'Активизировать',
    return: 'Вернуть',
    sendByEmail: 'Отправить по почте',
    sendAllActivatedByEmail: 'Отправить все активные по почте',
    SendToken: 'Отправить токен',
    note: 'Примечание',
    returnable: 'Данный продукт возвращаемый. Подробности в инструкции.',
    not_returnable: 'Данный продукт не подлежит возврату!',
    addToCart: 'Добавить в корзину',
    remove: 'Удалить',
    group: 'Группа',
    user: 'Пользователь',
    paid: 'Paid',
    paidHistory: 'Paid History',
    soldBy: 'Продано',
    Brands: 'Бренды',
    Clear: 'Очистить',
    language: 'Языки',
    delivery_time: 'Срок поставки',
    operating_systems: 'Операционные системы',
    license_type: 'Тип лицензии',
    users_count: 'Количество пользователей',
    devices_count: 'Количество устройств',
    tab_description: 'Описание',
    tab_requirement: 'Требования',
    tab_installation: 'Установка',
    login_esd_desc: '<b>ESD портал Techpro DC</b><br>Данный портал электронной дистрибуции программного обеспечения позволит вам размещать заказы на ПО в режиме онлайн в любое время 24/7. Срок доставки ключей: до 3 минут с момента заказа.<br><br><br>Новые пользователи - нажмите на "Стать партнером"',
    login_about: 'О нас',
    BecomePartner: 'Стать партнером',
    ResetPassword: 'Сброс пароля',
    PleaseEnterYourNewPassword: 'Пожалуйста, введите ваш новый пароль',
    FillTheBelowFormToBecomeAPartner: 'Заполните форму ниже, чтобы стать партнером',
    NameLastname: 'Имя Фамилия',
    Position: 'Должность',
    ContactNumber: 'Контактный телефон',
    CompanyVOEN: 'ИНН Компании',
    term: 'Я принимаю <a href="https://esd.techprodc.com/storage/81/muqavile_esd.az.pdf" target="_blank">условия</a>.',
    excelText1: 'Все цены на портале указаны в USD. Оплата производится в манатах по курсу USD в Pasha Bank на момент совершения оплаты. ',
    excelText2: 'Цены, указанные на портале, не включают НДС.',
    dealerPriceText: 'Диллерская Цена не включает НДС.',
    need_azn_cash: 'Нужно поле налички в AZN?',
    need_azn_credit: 'Нужно поле кредита в AZN?',
    cash: 'Наличные',
    credit: 'Кредит',
    net_tovara_v_korzine: 'У вас нет товаров в вашей корзине',
    activateAllKeys: 'Активизировать все ключи',
    need_create_adobe_account: 'Дополнительная информация', // Создать Adobe аккаунт?
    region: 'Регион',
    city: 'Город',
    addressLine1: 'Адресная строка 1',
    addressLine2: 'Адресная строка 2',
    postalCode: 'Почтовый индекс',
    marketSegments: 'Сегменты рынка',
    marketSegment: 'Сегмент рынка',
    has_adobe_account: 'Дополнительная информация', // Adobe аккаунт
    search: 'Поиск',
    makeAnOrder: 'Сделать заказ',
    full_name: 'Имя Фамилия',
    AdobeCustomer: 'Клиент Adobe',
    orderType: 'Тип заказа',
    getPrice: 'Получить цену',
    pricePerOne: 'Цена за одну',
    totalPrice: 'Общая цена',
    in_progress: 'В процессе',
    pending: 'В ожидании',
    for_x_days: '{days} дней',
}
